import React from "react";
import { Container, Box, Paper, Typography, Divider } from "@mui/material";
import BreadCrumbs from "../components/Breadcrumbs";

const LegalPage = () => {
    return (
        <Container maxWidth="xl" sx={{ mt: 3, mb: 5 }}>
            {/* Breadcrumbs */}
            <Box sx={{ mb: 3 }}>
                <BreadCrumbs hrefs="" name="Юридическая информация" />
            </Box>

            {/* Header */}
            <Paper sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
                    scraplands.ru — Юридическая информация
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Здесь размещены официальные документы, регулирующие использование сайта, услуги и правила.
                </Typography>
                <Divider sx={{ my: 3 }} />

                {/* Раздел 1. Публичная оферта */}
                <Typography variant="h5" fontWeight={500} gutterBottom>
                    Раздел 1. Публичная оферта
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                    <li>
                        <Typography fontWeight={600}>Общие положения</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Настоящая публичная оферта (далее — Оферта) определяет условия приобретения игровых товаров и услуг на сайте scraplands.ru (далее — Сайт) для игроков игрового сервера OverLive.
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Предмет оферты</Typography>
                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>
                                <Typography variant="body2">
                                    Сайт предоставляет игрокам возможность приобретать игровые товары (скины, предметы, привилегии и т.д.) для использования на игровом сервере OverLive.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Приобретенные товары выдаются игроку в игровом мире по команде <code>/shop</code> после успешной оплаты.
                                </Typography>
                            </li>
                        </Box>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Порядок приобретения и получения товаров</Typography>
                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>
                                <Typography variant="body2">
                                    Для приобретения товара игрок должен: выбрать товар в магазине на сайте, указать свой игровой никнейм, оплатить выбранный товар любым доступным способом.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    После успешной оплаты товар становится доступным для получения в игре по команде <code>/shop</code>.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Время доставки товара в игру обычно составляет от 1 до 5 минут после оплаты.
                                </Typography>
                            </li>
                        </Box>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Гарантии и ответственность</Typography>
                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>
                                <Typography variant="body2">
                                    Администрация сервера гарантирует выдачу приобретенных товаров при условии корректного указания игрового никнейма.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    В случае технических сбоев или ошибок при получении товара игрок может обратиться в службу поддержки.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Ответственность администрации ограничивается стоимостью приобретенного товара.
                                </Typography>
                            </li>
                        </Box>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Возврат и обмен</Typography>
                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>
                                <Typography variant="body2">
                                    Возврат денежных средств возможен только в случаях: технической ошибки при выдаче товара, невозможности получения товара по вине администрации.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Для оформления возврата необходимо обратиться в администрацию сервера через канал жалоб:
                                    <a style={{color:'#fafafa', marginLeft: '4px'}} href="https://t.me/overlive_ru/20" target="_blank" rel="noopener noreferrer">
                                        #жалобы-репорт
                                    </a>
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Решение о возврате принимается администрацией в индивидуальном порядке.
                                </Typography>
                            </li>
                        </Box>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Претензии и споры</Typography>
                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>
                                <Typography variant="body2">
                                    Все претензии и вопросы по приобретенным товарам направляются в администрацию сервера через канал:
                                    <a style={{color:'#fafafa', marginLeft: '4px'}} href="https://t.me/overlive_ru/20" target="_blank" rel="noopener noreferrer">
                                        #жалобы-репорт
                                    </a>
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Спорные ситуации, не урегулированные в досудебном порядке, решаются в соответствии с действующим законодательством РФ.
                                </Typography>
                            </li>
                        </Box>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Принятие условий</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Используя сайт scraplands.ru и совершая покупки, пользователь автоматически принимает все условия настоящей оферты.
                        </Typography>
                    </li>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Раздел 2. Политика конфиденциальности */}
                <Typography variant="h5" fontWeight={500} gutterBottom>
                    Раздел 2. Политика конфиденциальности
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                    <li>
                        <Typography fontWeight={600}>Сбор и обработка данных</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Сайт scraplands.ru собирает и обрабатывает следующие персональные данные пользователей: игровой никнейм, адрес электронной почты (при регистрации), данные платежных систем (для обработки оплаты).
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Цели обработки данных</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Персональные данные используются исключительно для: обработки заказов и выдачи товаров, связи с пользователем по вопросам заказов, предоставления технической поддержки.
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Защита данных</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Все данные хранятся с использованием современных методов защиты и не передаются третьим лицам без согласия пользователя, за исключением случаев, предусмотренных законодательством РФ.
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Права пользователей</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Пользователь имеет право на доступ, изменение и удаление своих данных, обратившись на <a style={{color:'#fafafa'}} href="mailto:support@scraplands.ru">support@scraplands.ru</a>.
                        </Typography>
                    </li>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Раздел 3. Общие положения */}
                <Typography variant="h5" fontWeight={500} gutterBottom>
                    Раздел 3. Общие положения
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                    <li>
                        <Typography fontWeight={600}>Изменения в документах</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Сайт scraplands.ru оставляет за собой право вносить изменения в оферту и политику конфиденциальности без предварительного уведомления.
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Вступление в силу</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Новая редакция документов вступает в силу с момента публикации на сайте.
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Отслеживание изменений</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Пользователь обязан самостоятельно отслеживать изменения документов. Продолжение использования сайта после внесения изменений означает автоматическое принятие новых условий.
                        </Typography>
                    </li>
                    <li>
                        <Typography fontWeight={600}>Контактная информация</Typography>
                        <Box component="ul" sx={{ pl: 3 }}>
                            <li>
                                <Typography variant="body2">
                                    Техническая поддержка: <a style={{color:'#fafafa'}} href="mailto:support@scraplands.ru">support@scraplands.ru</a>
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Администрация сервера: <a style={{color:'#fafafa'}} href="https://t.me/overlive_ru/20" target="_blank" rel="noopener noreferrer">#жалобы-репорт</a>
                                </Typography>
                            </li>
                        </Box>
                    </li>
                </Box>
            </Paper>
        </Container>
    );
};

export default LegalPage;
